import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { PRODUCT_BUILD } from '../../constants/build';
import { getEnvironment } from '../environment';
import { SENTRY_DSN, UNKNOWN_TAG } from './constants';
var Sentry;
var beforeSend = function beforeSend(event) {
  var _event$request, _event$request2;
  // Delete the query string as it contains UGC
  if ((_event$request = event.request) !== null && _event$request !== void 0 && _event$request.url) {
    event.request.url = event.request.url.split('?')[0];
  }
  if ((_event$request2 = event.request) !== null && _event$request2 !== void 0 && (_event$request2 = _event$request2.headers) !== null && _event$request2 !== void 0 && _event$request2.Referer) {
    event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
  }
  if (event.environment === 'development') {
    return null;
  }
  return event;
};
export var getSentryClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!Sentry) {
            Sentry = import( /* webpackChunkName: "@atlaskit-internal_@atlassian/search-ai/sentry" */'@sentry/browser').then(function (SentryModule) {
              SentryModule.init({
                dsn: SENTRY_DSN,
                attachStacktrace: true,
                release: PRODUCT_BUILD || UNKNOWN_TAG,
                environment: getEnvironment(),
                beforeSend: beforeSend
              });
              return SentryModule;
            }).catch(function () {
              // TODO: Retry mechanism for chunk loading failures?
            });
          }
          return _context.abrupt("return", Sentry);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSentryClient() {
    return _ref.apply(this, arguments);
  };
}();